// src/lib/api/contactApi.ts

import { getApiClient } from './client';

export interface ContactFormData {
    name: string;
    email: string;
    municipality: string;
    message: string;
    type: 'demo' | 'pilot';
    website?: string; // honeypot — must stay empty for legit submissions
}

export interface ContactResponse {
    message: string;
    warning?: string; // Optional warning if email fails but form was saved
}

const submitContactForm = async (data: ContactFormData): Promise<ContactResponse> => {
    console.log('[contactApi] Submitting contact form:', data);
    const result = await getApiClient().publicPost<ContactResponse>('/api/contact', data);
    console.log('[contactApi] Contact form submitted successfully:', result);
    return result;
};

export const contactApi = {
    submitContactForm,
};
